import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/psychology-app/chief-tutor.png"
}, null, -1);
import AppBanner from "@/components/psychology-app/app-banner.vue";
import FunctionModule from "@/components/psychology-app/function-module.vue";
import MemberRights from "@/components/psychology-app/member-rights.vue";
import { useMeta } from "vue-meta";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    useMeta({
      title: "全民幸福社APP",
      htmlAttrs: {
        lang: "en",
        amp: true
      },
      meta: [{
        name: "description",
        content: "读, 学, 练, 测, 评 的学习场景"
      }, {
        name: "kewords",
        content: "心理学读书,专业心理学测评服务,全民幸福社"
      }]
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(AppBanner), _createVNode(FunctionModule), _createVNode(MemberRights), _hoisted_1]);
    };
  }
});